<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .container {
    padding: utils.in_rem(24px);
    width: utils.in_rem(400px);
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(8px);
  }
</style>

<script>
  // Stores
  import { flagContactReasonStore } from "../../ProfileContactSideBar/stores";
  // Components
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  import Separator from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Separator.svelte";
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";

  export let isEmail = false;

  const items = [
    { value: "invalid", text: `Invalid ${isEmail ? "email" : "phone number"}` },
    { value: "old", text: "Data out of date" },
    { value: "wrongPerson", text: "Wrong person" },
    { value: "other", text: "Other" },
  ];

  let closeDropdown;

  const makeClickHandler = (item) => (selected) => {
    $flagContactReasonStore = (selected && item) || {};
    closeDropdown();
  };
</script>

<div class="container">
  <Dropdown kind="input-field" bind:close={closeDropdown} size="large">
    <div slot="button">
      {$flagContactReasonStore.text || "Reason (optional)"}
    </div>

    <ListItem
      slot="header"
      onclick={() => {
        $flagContactReasonStore = {};
        closeDropdown();
      }}
      icon="fa-times"
    >
      Clear selection
    </ListItem>

    <Separator />

    {#each items as item}
      <ListItem
        onclick={makeClickHandler(item)}
        selected={$flagContactReasonStore.value === item.value}
      >
        {item.text}
      </ListItem>
    {/each}
  </Dropdown>

  {#if $flagContactReasonStore.value === "other"}
    <TextInput
      placeholder="Please explain..."
      bind:value={$flagContactReasonStore.explanation}
      autoFocus={true}
    />
  {/if}
</div>
